import { Button } from '@mui/material';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';

interface Props {
  onClick: () => void;
  loading: boolean;
  loadingText?: string;
  text: string;
}

const GlencoreButton = (props: Props) => {
  const { onClick, loading, text, loadingText } = props;

  const { theme } = useAppSelector((state) => state.authReducer.customer);
  const darkMode = isDarkTheme(theme);

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      disabled={loading}
      sx={{
        height: '40px',
        borderRadius: '8px',
        textTransform: 'none',
        fontWeight: 600,
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
        color: darkMode ? '#000' : '#fff',
        backgroundColor: darkMode ? '#e3f2fd' : '#092b63',
        '&:hover': {
          backgroundColor: darkMode ? '#e3f2fd' : '#1e3cc7',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        },
      }}
    >
      {loading ? loadingText ?? 'Loading...' : text}
    </Button>
  );
};

export default GlencoreButton;
